<template>
  <v-content>
    <v-container fluid>
      <ResearchParameters
        :medias="medias"
        @search="search"
      />
      <ResearchResults :rows="medias" />
    </v-container>
  </v-content>
</template>

<script>
  import ResearchParameters from './ResearchParameters';
  import httpClient from '../../infra/httpClient';
  import Api from '../../../admin/js/services/Api';
  import ResearchResults from './ResearchResults';

  const endpoint = 'data/analytic_research';

  export default {
    components: { ResearchResults, ResearchParameters },
    data: function () {
        return {
          api: new Api('/', httpClient),
          medias: [],
          periodicities: [
            {
              value: 'continuous',
              text: 'Atualização Contínua',
            },
            {
              value: 'daily',
              text: 'Diário',
            },
            {
              value: 'biweekly',
              text: 'Bisemanal',
            },
            {
              value: 'triweekly',
              text: 'Trisemanal',
            },
            {
              value: 'monfri',
              text: 'Segunda à Sexta',
            },
            {
              value: 'monsat',
              text: 'Segunda à Sábado',
            },
            {
              value: 'weekly',
              text: 'Semanal',
            },
            {
              value: 'fortnightly',
              text: 'Quinzenal',
            },
            {
              value: 'monthly',
              text: 'Mensal',
            },
            {
              value: 'bimonthly',
              text: 'Bimestral',
            },
            {
              value: 'trimonthly',
              text: 'Trimestral',
            },
            {
              value: 'undefined',
              text: 'Sem periodicidade definida',
            },
            {
              value: 'another',
              text: 'Outro',
            },
          ]
        }
    },
    methods: {
      async search(filters) {

        const params = {};

        if (filters.name) {
          params.nome_veiculo = [];
          params.nome_veiculo['lk'] = filters.name
        }

        if (filters.segments.length > 0) {
          params.segment_id = filters.segments.map(s => s)
        }

        if (filters.regions.length > 0) {
          params.region_id = filters.regions.map(s => s)
        }

        if (filters.states.length > 0) {
          params.state_id = filters.states.map(s => s)
        }

        if (filters.cities.length > 0) {
          params.city_id = filters.cities.map(s => s)
        }

        if (filters.mediaSources.length > 0) {
          params.media_source_id = filters.mediaSources.map(s => s)
        }

        if (filters.employeesRanges.length > 0) {
          params.employees_range_id = filters.employeesRanges.map(s => s)
        }

        if (filters.hasEmail !== undefined && filters.hasEmail !== null) {
            params.has_email = filters.hasEmail;
        }

        if (filters.hasSocial !== undefined && filters.hasSocial !== null) {
            params.has_social = filters.hasSocial;
        }

        document.getElementById('loader-wrapper').classList.remove('hidden');
        const data = await this.api.research(params, endpoint);
        this.medias = data.map(d => {
          const pd = this.periodicities.find(p => p.value === d.periodicity);
          if (pd === undefined) {
            d.periodicity = 'Não definida';
          } else {
            d.periodicity = pd.text;
          }

          d.eh_jornal = d.eh_jornal === 1 ? 'Sim' : 'Não';
          d.eh_site_pago = d.eh_site_pago === 1 ? 'Sim' : 'Não';
          if (d.data_fechamento) {
            d.data_fechamento = d.data_fechamento.substr(5,2) + '/' + d.data_fechamento.substr(0,4);
          }

          return d;
        });
        document.getElementById('loader-wrapper').classList.add('hidden');
      }
    }
  };
</script>

<style scoped>

</style>
